export const topicsPerBusinessUnits = {
  topics: [
    "Digital Transformation",
    "Sustainability",
    "Data & Cyber Security",
    "Recruiting",
    "Operational Excellence",
    "Business Development",
    "Mergers & Acquisitions",
  ],
  units: [
    "Finance & Accounting",
    "Human Resources",
    "Controlling",
    "Compliance",
    "Product Management",
    "Marketing",
    "Sales",
    "Corporate Strategy",
    "IT",
    "Supply Chain Management",
  ],
};
